import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

export const OfflineBanner = () => {
  const { t } = useTranslation();
  const [isOffline, setIsOffline] = useState(!navigator.onLine);

  useEffect(() => {
    const handleOffline = () => setIsOffline(true);
    const handleOnline = () => setIsOffline(false);

    window.addEventListener("offline", handleOffline);
    window.addEventListener("online", handleOnline);

    return () => {
      window.removeEventListener("offline", handleOffline);
      window.removeEventListener("online", handleOnline);
    };
  }, []);

  if (!isOffline) return null;

  return (
    <div
      role="alert"
      className="fixed top-0 left-0 right-0 z-[70] flex items-center justify-center gap-2 bg-amber-600 py-2 px-4 text-sm font-medium text-white shadow-md"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="h-4 w-4 shrink-0"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M12 9v4" />
        <path d="M12 17h.01" />
        <path d="M2.73 21h18.53a1 1 0 0 0 .87-1.5l-9.27-16a1 1 0 0 0-1.73 0l-9.27 16a1 1 0 0 0 .87 1.5z" />
      </svg>
      {t("offline_banner")}
    </div>
  );
};
